var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loadComplete)?_c('div',[_c('cSplashCarousel',{attrs:{"pages":_vm.splashPages}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }